// extracted by mini-css-extract-plugin
module.exports = {"mains":"View4_mains__3dCJ-","user":"View4_user__9Fx3o"};